<template>
  <v-navigation-drawer v-model="mini" width="400px" temporary app>
    <div class="px-2">
      <default-drawer-header />

      <v-divider class="mx-3 mb-2" />

      <default-list :items="items" />
    </div>

    <div class="pt-12" />
  </v-navigation-drawer>
</template>

<script>
// Utilities
import { get, sync } from "vuex-pathify";
import axios from "axios";

export default {
  name: "DefaultDrawer",

  components: {
    DefaultDrawerHeader: () =>
      import(
        /* webpackChunkName: "default-drawer-header" */
        "./widgets/DrawerHeader"
      ),
    DefaultList: () =>
      import(
        /* webpackChunkName: "default-list" */
        "./List"
      ),
  },
  data: () => ({
    isLogin: false,
  }),
  computed: {
    ...get("user", ["dark", "gradient", "image"]),
    ...get("app", ["version", "apiUrl"]),
    ...sync("app", ["items", "drawer", "drawerImage", "mini"]),
  },
  mounted() {
    if (localStorage.getItem("user") || false) {
      this.isLogin = true;
    }
    this.getMenu();
  },

  methods: {
    getMenu() {
      const self = this;
      if (!self.isLogin) return;

      axios({
        url: self.apiUrl + "api/Menus/OfUser",
        method: "GET",
      })
        .then(function(res) {
          res.data.forEach((element) => {
            if (element.menumodel === null || element.menumodel.length === 0)
              delete element.menumodel;
            else {
              element.menumodel.forEach((element1) => {
                if (
                  element1.menumodel === null ||
                  element1.menumodel.length === 0
                )
                  delete element1.menumodel;
              });
            }
          });
          self.items = res.data;
          //self.items = res.data;
        })
        .catch(function(err) {
          self.message = err.status;

          self.message = "Data Not Found";
          self.snackbar = true;
        });
    },
  },
};
</script>

<style lang="sass"></style>
